<div class="container">
    @if (isLoading) {
    <div class="loadingOverlay center-loader">
        <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7"
            animationDuration="0.5s"></p-progressSpinner>
    </div>
    }

    <div class="navigation">
        <div class="neo-tabs">
            @for (category of categories; track $index) {
            <div class="neo-tab" [class.active]="category.isActive" (click)="openCategory(category.name)"
                (keydown)="handleKeydown($event, category.name)" [tabindex]="$index">
                <img [src]="category.icon" class="tab-icon" [alt]="category.name + ' icon'" />
                {{category.name}}
            </div>
            }
        </div>
        @if(activeComponent === "User Management") {
        <div class="navigation-action">
            <div class="switch-tab" *ngIf="userPrivileges.has('user.view') || userPrivileges.has('role.view')">
                <div class="neo-tabs">
                    <div *ngIf="userPrivileges.has('user.view')" class="neo-tab" (click)="activeUserManagementTab.set('users')"
                        [class.active]="activeUserManagementTab() === 'users'">
                        Users
                    </div>
                    <div *ngIf="userPrivileges.has('role.view')" class="neo-tab" (click)="activeUserManagementTab.set('roles')"
                        [class.active]="activeUserManagementTab() === 'roles'">
                        Roles
                    </div>
                </div>
            </div>
            @if (activeUserManagementTab() === "users" && userPrivileges.has('user.create')) {
            <button pButton class="create-btn" (click)="userManagementAddAction()">
                Add New
            </button>
            }
            @if (activeUserManagementTab() === "roles" && userPrivileges.has('role.create')) {
            <button pButton class="create-btn" (click)="userManagementAddAction()">
                Add New
            </button>
            }
        </div>
        }
        @if(activeComponent === "Email Templates" && userPrivileges.has('email_template.create')) {
        <button pButton class="create-btn" (click)="createNewTemplate$.next()">
            Create New Template
        </button>
        }
        @if(activeComponent === "Form Builder" && userPrivileges.has('form_builder.create')) {
        <button pButton class="create-btn" (click)="createNewForm$.next()">
            Create New Form
        </button>
        }
    </div>

    <div class="content">
        @if (activeComponent === 'Account') {
        <app-primary-account></app-primary-account>
        }
        @if (activeComponent === "Company Details") {
        <app-company-details></app-company-details>
        }
        @if(activeComponent === "User Management") {
        @if(activeUserManagementTab() === "users") {
        <app-user-list [addUser$]="addUser$"></app-user-list>
        } @else {
        <app-role-and-permission [forceRolesTab]="true" [addRole$]="addRole$"></app-role-and-permission>
        }
        }
        @if (activeComponent === "Email Templates") {
        <app-email-template [createNewTemplate$]="createNewTemplate$"></app-email-template>
        }
        @if(activeComponent === "Configuration") {
        <app-configuration-settings></app-configuration-settings>
        }
        @if (activeComponent === "Form Builder") {
        <app-form-list [createNewForm$]="createNewForm$"></app-form-list>
        }
        @if (activeComponent === "Integrations") {
        <app-integrations></app-integrations>
        }
    </div>
</div>

<!-- Old HTML -->
<!-- <div class="generalSettings-container">
    <div *ngIf="isLoading" class="loadingOverlay">
        <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s"></p-progressSpinner>
    </div>
    
    <div class="generalSettings-header">
        <p>General Settings</p>
    </div>

    <div class="generalSettings-content">
        <div class="categories">
            <button class="category" 
                    id="category-{{catInx}}" 
                    [ngClass]="{'active' : category.isActive}" 
                    *ngFor="let category of categories; let catInx = index"
                    (click)="openCategory(category.name)" 
                    (keydown)="handleKeydown($event, category.name)" 
                    tabindex="{{catInx}}">
                <p>{{category.name}}</p>
            </button>
        </div>

        <div class="settings-container">
            <div *ngIf="activeComponent === 'Primary Account'">
                <app-primary-account></app-primary-account>
            </div>
            <div *ngIf="activeComponent === 'Company Details'">
                <app-company-details></app-company-details>
            </div>
            <div *ngIf="activeComponent === 'Branches'">
                <app-branches></app-branches>
            </div>
            <div *ngIf="activeComponent === 'Date and Time'">
                <app-date-time-settings></app-date-time-settings>
            </div>
            <div *ngIf="activeComponent === 'User Management'">
                <app-role-and-permission></app-role-and-permission>
            </div>
            <div *ngIf="activeComponent === 'Email Template'">
                <app-email-template></app-email-template>
            </div>
            <div *ngIf="activeComponent === 'Form Builder'">
                <app-form-list></app-form-list>
            </div>            
            <div *ngIf="activeComponent === 'Platform Configuration'" class="platform-config-wrapper">
                <div class="platform-config-header">
                  <p class="platform-config-title">Platform Configuration</p>
                </div>
              
                <div class="platform-config-menu">
                  <button
                    *ngFor="let option of platformOptions"
                    (click)="setActiveSubOption(option)"
                    [ngClass]="{ 'active': activeSubOption === option }"
                    class="platform-tab"
                  >
                    {{ option }}
                  </button>
                </div>
                <div class="platform-config-content">
                  <app-option-value-add [activeComponent]="activeSubOption"></app-option-value-add>
                </div>
              </div>              
    </div>

    <p-toast></p-toast>
</div> -->